"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = exports.getIconConstructor = exports.defaultSize = exports.IconVariant = exports.Orientation = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var classnames_1 = require("classnames");
var Icons = require("./icons");
var Orientation;
(function (Orientation) {
    Orientation["Right"] = "right";
    Orientation["Down"] = "down";
    Orientation["Left"] = "left";
    Orientation["Up"] = "up";
})(Orientation = exports.Orientation || (exports.Orientation = {}));
var IconVariant;
(function (IconVariant) {
    IconVariant["add"] = "Add";
    IconVariant["addToQueue"] = "AddToQueue";
    IconVariant["arrowBackward"] = "ArrowBackward";
    IconVariant["arrowDown"] = "ArrowDown";
    IconVariant["arrowForward"] = "ArrowForward";
    IconVariant["arrowLeft"] = "ArrowLeft";
    IconVariant["arrowRight"] = "ArrowRight";
    IconVariant["arrowUp"] = "ArrowUp";
    IconVariant["barChart"] = "BarChart";
    IconVariant["calendar"] = "Calendar";
    IconVariant["call"] = "Call";
    IconVariant["chatBubble"] = "ChatBubble";
    IconVariant["checkbox"] = "Checkbox";
    IconVariant["chevron"] = "Chevron";
    IconVariant["circle"] = "Circle";
    IconVariant["close"] = "Close";
    IconVariant["default"] = "Default";
    IconVariant["delete"] = "Delete";
    IconVariant["document"] = "Document";
    IconVariant["doughnutChart"] = "DoughnutChart";
    IconVariant["edit"] = "Edit";
    IconVariant["error"] = "Error";
    IconVariant["filter"] = "Filter";
    IconVariant["information"] = "Information";
    IconVariant["linked"] = "Linked";
    IconVariant["mail"] = "Mail";
    IconVariant["menu"] = "Menu";
    IconVariant["menuDots"] = "MenuDots";
    IconVariant["money"] = "Money";
    IconVariant["search"] = "Search";
    IconVariant["shop"] = "Shop";
    IconVariant["success"] = "Success";
    IconVariant["tableArrowDown"] = "TableArrowDown";
    IconVariant["tableArrowLeft"] = "TableArrowLeft";
    IconVariant["tableArrowRight"] = "TableArrowRight";
    IconVariant["tableArrowUp"] = "TableArrowUp";
    IconVariant["time"] = "Time";
    IconVariant["user"] = "User";
    IconVariant["warning"] = "Warning";
})(IconVariant = exports.IconVariant || (exports.IconVariant = {}));
exports.defaultSize = 20;
exports.getIconConstructor = function (variant) {
    switch (variant) {
        case IconVariant.add:
            return Icons.Add;
        case IconVariant.addToQueue:
            return Icons.AddToQueue;
        case IconVariant.arrowBackward:
            return Icons.ArrowBackward;
        case IconVariant.arrowDown:
            return Icons.ArrowDown;
        case IconVariant.arrowForward:
            return Icons.ArrowForward;
        case IconVariant.arrowLeft:
            return Icons.ArrowLeft;
        case IconVariant.arrowRight:
            return Icons.ArrowRight;
        case IconVariant.arrowUp:
            return Icons.ArrowUp;
        case IconVariant.barChart:
            return Icons.BarChart;
        case IconVariant.calendar:
            return Icons.Calendar;
        case IconVariant.call:
            return Icons.Call;
        case IconVariant.chatBubble:
            return Icons.ChatBubble;
        case IconVariant.checkbox:
            return Icons.Checkbox;
        case IconVariant.chevron:
            return Icons.Chevron;
        case IconVariant.circle:
            return Icons.Circle;
        case IconVariant.close:
            return Icons.Close;
        case IconVariant.delete:
            return Icons.Delete;
        case IconVariant.document:
            return Icons.Document;
        case IconVariant.doughnutChart:
            return Icons.DoughnutChart;
        case IconVariant.edit:
            return Icons.Edit;
        case IconVariant.error:
            return Icons.ErrorCircle;
        case IconVariant.filter:
            return Icons.Filter;
        case IconVariant.information:
            return Icons.Information;
        case IconVariant.linked:
            return Icons.Linked;
        case IconVariant.mail:
            return Icons.Mail;
        case IconVariant.menu:
            return Icons.Menu;
        case IconVariant.menuDots:
            return Icons.MenuDots;
        case IconVariant.money:
            return Icons.Money;
        case IconVariant.search:
            return Icons.Search;
        case IconVariant.shop:
            return Icons.Shop;
        case IconVariant.success:
            return Icons.Success;
        case IconVariant.tableArrowDown:
            return Icons.TableArrowDown;
        case IconVariant.tableArrowLeft:
            return Icons.TableArrowLeft;
        case IconVariant.tableArrowRight:
            return Icons.TableArrowRight;
        case IconVariant.tableArrowUp:
            return Icons.TableArrowUp;
        case IconVariant.time:
            return Icons.Time;
        case IconVariant.user:
            return Icons.User;
        case IconVariant.warning:
            return Icons.Warning;
        default:
            console.error("No icon found named \"" + variant + "\"");
            return null;
    }
};
exports.Icon = function (props) {
    var _a;
    var classes = classnames_1.default((_a = {},
        _a[props.className] = !!props.className,
        _a.defaultStyle = !props.className,
        _a));
    var IconConstructor = exports.getIconConstructor(props.variant);
    if (!IconConstructor) {
        return null;
    }
    // @ts-ignore
    return React.createElement(IconConstructor, tslib_1.__assign({}, props, { className: classes, "aria-hidden": "true" }));
};
exports.Icon.defaultProps = {
    strokeWidth: 3,
    variant: IconVariant.default,
};
//# sourceMappingURL=Icon.js.map